import { SyncOutlined } from '@ant-design/icons';
import { CallSyncKakaoTalkResultRequest } from '@gooduncles/gu-app-schema';
import { Button, message } from 'antd';
import { FC, useCallback, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { callSyncKakaoTalkResult } from 'src/utils/firebase/firebase-callable';

const AgCellSyncMessageResultButton: FC<CallSyncKakaoTalkResultRequest> = ({
  type,
  messageDocId,
  requestId,
  recipientSeq,
}) => {
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(async () => {
    setLoading(true);
    try {
      const result = await callSyncKakaoTalkResult({
        type,
        messageDocId,
        requestId,
        recipientSeq,
      });
      if (result.data.result === 'success') {
        message.success('동기화 완료');
      } else {
        message.error(result.data.reason ?? '알 수 없는 오류 발생');
      }
    } catch (error) {
      console.error(error);
      const message = errorObjectToString(error);
      message.error({
        message,
      });
    }
    setLoading(false);
  }, [type, messageDocId, recipientSeq, requestId]);

  return (
    <Button type='primary' size='small' icon={<SyncOutlined />} loading={loading} onClick={onClick}>
      결과조회
    </Button>
  );
};

export default AgCellSyncMessageResultButton;
